import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from 'antd'

export function RootErrorBoundary() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : '应用暂时无法加载'
  return <main className="route-state"><span>!</span><h1>{message}</h1><p>请刷新页面重试；如果问题持续存在，请联系管理员。</p><Button type="primary" onClick={() => window.location.reload()}>重新加载</Button></main>
}
